import { CodeOfConduct } from "./CodeOfConduct";

export default CodeOfConduct;
